import { CHART_COLORS, seriesColumnConfig } from './chartStyle';

/**
 * Function to generate configuration for a registrations chart using ant-design/charts.
 *
 * @function
 * @param {Array} data - The chart data.
 * @returns {Object} - Configuration object for the registrations chart.
 */
export const registrationConfig = (data) => ({
  ...seriesColumnConfig({
    domain: ['Propriétaires', 'Retraités'],
    colors: [CHART_COLORS.cambridge, CHART_COLORS.pear],
    stack: true
  }),
  data,
  xField: 'month',
  yField: 'sales',
  tooltip: {
    items: [(item) => ({ name: item.type, value: `${item.sales} ` })]
  }
});
